export function savePreferences(key, prefs) {
    try {
        window.localStorage.setItem("prefs_" + key, JSON.stringify(prefs));
    } catch (e) {
        removePreferences(key);
    }
}

export function loadPreferences(key) {
    try {
        let prefs = JSON.parse(window.localStorage.getItem("prefs_" + key));
        return prefs;
    } catch (e) {
        return false;
    }
}

export function removePreferences(key) {
    try {
        window.localStorage.removeItem("prefs_" + key);
    } catch (e) {
        console.log('removePreferences', e);
    }
}

export function clearPreferences() {
    for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key.startsWith('prefs_')) {
            localStorage.removeItem(key);
        }
    }
}
